import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "section"]

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => this.onIntersect(entries),
      { rootMargin: "-20% 0px -60% 0px" }
    )
    this.sectionTargets.forEach((section) => this.observer.observe(section))
    if (this.linkTargets.length > 0) this.activate(this.linkTargets[0])
  }

  disconnect() {
    this.observer?.disconnect()
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const id = entry.target.id
        const link = this.linkTargets.find((l) => l.getAttribute("href") === `#${id}`)
        if (link) this.activate(link)
      }
    })
  }

  navigate(event) {
    event.preventDefault()
    const href = event.currentTarget.getAttribute("href")
    const target = document.querySelector(href)
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" })
      this.activate(event.currentTarget)
    }
  }

  activate(activeLink) {
    this.linkTargets.forEach((link) => link.classList.remove("guide-nav-link--active"))
    activeLink.classList.add("guide-nav-link--active")
    // Scroll the active link into view in the mobile nav
    activeLink.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" })
  }
}
